<template>
  <teleport to="body">
    <div id="fb-root"></div>
  </teleport>
  <div class="fb-post-root">
    <div class="fb-post" :data-href="getSrc()" data-show-text="true"></div>
  </div>
</template>

<script setup lang="ts">

import loadEmbedScript from "~/server/utils/request/loadEmbedScript";

const {payload} = defineProps < {
  payload? : any
} > ()

const getSrc = () => {
  return payload.attributes.src
}

// TODO: not working without FB API review
if (window) {
  loadEmbedScript(
    "facebook",
    "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v20.0&appId=812201847640436",
    {
      "async": "",
      "defer": "",
      "crossorigin": "anonymous",
      "nonce": "UNC4mOpb"
    },
    () => {console.log("emby")}
  )
}

</script>

<style scoped lang="postcss">
</style>
